import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const MULTIPLE = 'multiple';

const Input = styled.input`
  -moz-appearance:textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
  }
`;

class WveInputNumber extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.convertInputToSensibleNumber(props.value),
    };
    this.shouldUpdate = false;
  }
  decimalsForStep() {
    return this.props.step < 1 ? 1 : 0;
  }
  convertInputToSensibleNumber(value) {
    // if a non numeric value such as 'multiple' is set, this
    // returns 'NaN', which for now we can use to determine
    // if the user has entered a value or not
    return parseFloat(value).toFixed(this.decimalsForStep());
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ value: this.convertInputToSensibleNumber(nextProps.value) });
  }

  handleChange = (e) => {
    this.setState({ value: e.target.value })
  };

  handleBlur = (e) => {
    // No point doing anything if the value is not a number
    if (this.state.value === 'NaN') { return };

    this.setState({ value: this.props.handleUpdate(e) });
  }

  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.input.blur();
    } else if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      this.props.handleUpdate(e);
      e.preventDefault();
    } else {
      this.setState({ value: this.props.handleUpdate(e) });
    }
  }
  render() {
    const {
        title = '',
        value,
        units = '',
        handleUpdate,
        handleKeyUp,
        min,
        max,
        step,
        positionInArray = -1,
        placeholder = '',
        removable = false,
        disabled,
    } = this.props;

    // when multiple keyframes selected, props.value is 'multiple'
    // `convertInputToSensibleNumber` will set state to 'NaN'
    // so this hack lets us know if the user has entered a number or not
    const isMultiple = value === MULTIPLE && this.state.value === 'NaN';
    const valueToShow = isMultiple ? '' : this.state.value;

    return (
      <div
        className={`wve-form-item wve-input-hint
          ${title !== '' && ' wve-input-hint-left '}
          ${units !== '' && ' wve-input-hint-right '}
          ${removable && ' wve-input-removable '}
        `}
        data-hint-left={title}
        data-hint-right={units}
      >
        <Input
          type="number"
          className={'form-control input-sm'}
          placeholder={ isMultiple ? 'multi' : placeholder }
          value={valueToShow}
          required=""
          min={min}
          max={max}
          step={step}
          data-id={positionInArray}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          onKeyUp={this.handleKeyDown}
          innerRef={(input) => { this.input = input; }}
          disabled={disabled}
        />
      </div>
  )}
}


WveInputNumber.propTypes = {
  title: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  handleUpdate: PropTypes.func,
  handleKeyUp: PropTypes.func,
  placeholder: PropTypes.string,
};

export default WveInputNumber;



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/components/WveInputs/WveInputNumber/WveInputNumber.jsx